import styled from 'styled-components';

import { colorsMatrix, FormLabel, Modal, ModalWidth, resolveInputLayoutStyles } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

const StyledElectronicReferralFailureModal = styled.div`
   ${resolveInputLayoutStyles};
   max-width: 750px;
`;
StyledElectronicReferralFailureModal.displayName = 'StyledElectronicReferralFailureModal';

const StyledErrorsList = styled.div`
   max-height: 300px;
   overflow-y: auto;

   ul {
      list-style: none;

      li {
         position: relative;

         &::before {
            content: '\\2022';
            position: absolute;
            color: ${colorsMatrix.blue.basic};
            font-weight: bold;
            display: inline-block;
            width: 1px;
            left: -12px;
         }
      }
   }
`;
StyledErrorsList.displayName = 'StyledErrorsList';

type ElectronicReferralFailureModalProps = {
   readonly onConfirm: () => void;
   readonly onCancel: () => void;
   readonly errors?: string[];
};

export const ElectronicReferralFailureModal = (props: ElectronicReferralFailureModalProps): JSX.Element => {
   return (
      <Modal
         title={referralTranslationKeys.electronicReferralFailureModal.referralSendFail}
         confirmationButtonLabel={referralTranslationKeys.electronicReferralFailureModal.print}
         onConfirm={props.onConfirm}
         onCancel={props.onCancel}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         visible
         testId={'electronicReferralFailure'}
      >
         <StyledElectronicReferralFailureModal>
            <FormLabel
               label={referralTranslationKeys.electronicReferralFailureModal.identifiedErrors}
               testId={'identifiedErrors'}
            />
            <StyledErrorsList>
               <ul>
                  {props.errors?.map((error) => (
                     <li key={error}>{error}</li>
                  ))}
               </ul>
            </StyledErrorsList>
         </StyledElectronicReferralFailureModal>
      </Modal>
   );
};
